import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import SubHead from './SubHead';


const NavHead = ({ data, className }) => {
	try {
		const dataId = data.replace(/[\W_]+/g, '').replace(/\s+/g, '-').toLowerCase();
		const navHeadClass = `sub-head ${className}`;
		return (<a id={dataId}><SubHead className={navHeadClass} data={data} /></a>)
	} catch (e) {
		console.log(e);
		return null;
	}
	
};

NavHead.propTypes = {
  data: PropTypes.string,
  className: PropTypes.string,
};

export default NavHead;
